<template>
    <div class="popover-copy">
        <div class="popover-header">
            <label>{{ plan.name }}</label>&nbsp;
            <button type="button" aria-label="Close" class="close"><span aria-hidden="true" v-close-popover>×</span>
            </button>
        </div>
        <div class="popover-body">
                <scrollable-select @change="selectedDay = $event.value">
                  <template v-slot:options>
                    <option v-for="day in availableDays" :value="day">
                      <template v-if="MENU_MODE">
                        {{day.name()}}
                      </template>
                      <template v-else>
                        {{ 'app.day' | trans }} {{ getDayIndexById(day.id) + 1 }}
                      </template>
                    </option>
                  </template>
                </scrollable-select>
            <div v-if="selectedDay && selectedDay.hasPlan(plan.name)">
                <div class="alert alert-warning">
                    Posiłek o podanej nazwie już istnieje w
                    dniu {{selectedDay.date | format_date}} {{selectedDay.date | format_date('dddd') | capitalize}}.
                    Co chcesz zrobić?
                </div>
                <label>Co zrobić...</label><br>
                <select v-model="mode" class="form-control input-sm">
                    <option value="add">Dodaj jako nowy posiłek</option>
                    <option value="replace">Zamień posiłek</option>
                    <option value="merge">Połącz z posiłkiem</option>
                </select>
            </div>
        </div>

        <div class="popover-footer">
            <button :disabled="selectedDay === null" class="btn btn-success" @click="copy" v-close-popover>Kopiuj</button>
            <button class="btn btn-default" v-close-popover>Zamknij</button>
        </div>
    </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters } from 'vuex';
  import { copyFood, copyPlan, copyProduct } from '../../services/CopyMenuDay';
  import { createTimestampFromDateAndTime } from '../../utils/dateFormatter';
  import {multiPortionFoodsManager} from "../../services/MultiPortionFoodsManager";

  export default {
    props: [
      'dayId', 'planId',
    ],
    created() {
      this.plan = this.getPlan(this.dayId, this.planId);
    },
    data() {
      return {
        plan: null,
        selectedDay: null,
        mode: 'add',
      };
    },
    computed: {
      ...mapState({
        menu(state) {
          return state.menu;
        },
        days(state) {
          if (state.menu.schema)
            return state.menu.schema.days;
        },
        schema: state => state.menu.schema,
      }),
      ...mapGetters(['MENU_MODE', 'getDayIndexById']),
      availableDays() {
        return this.days;
      },
    },
    methods: {
      ...mapMutations([
        'checkPlanRepetition',
      ]),
      getPlan(dayId, planId) {
        return this.$store.getters.getDayById(dayId).getPlan(planId);
      },
      getDay(dayId) {
        return this.$store.getters.getDayById(dayId);
      },

      copyPlan() {
        const plan = copyPlan(this.plan,
            createTimestampFromDateAndTime(this.selectedDay.date, this.plan.time),
            this.schema
        );
        this.selectedDay.addPlan(plan);
        this.checkPlanRepetition(plan);
      },
      copy() {
        if (this.mode === 'add') {
          this.copyPlan();
        }

        if (this.mode === 'merge') {
          const selectedPlan = this.selectedDay.getPlanBy(this.plan.name);
          this.plan.foods.map(food => {
              let foodCopy;
              if (food.isMultiPortionFood()) {
                  foodCopy = multiPortionFoodsManager.copyMultiPortionFood(food, this.schema);
              } else {
                  foodCopy = copyFood(food);
              }
              selectedPlan.addFood(foodCopy);
          });
          this.plan.products.map(p => selectedPlan.addProduct(copyProduct(p)));

          this.checkPlanRepetition(selectedPlan);
        }

        if (this.mode === 'replace') {
          const exist = this.selectedDay.getPlanBy(this.plan.name);
          this.selectedDay.removePlan(exist.id);
          this.copyPlan();
        }

        this.$toasted.global.success({ message: 'Posiłek został skopiowany!' });
        this.selectedDay = null;
      },
    },
  };
</script>

